import { randomString } from '@ps/utils';

const SURVEY_QUOTA_ID_LENGTH = 15;

export const generateSurveyQuotaId = (): string => {
  return randomString(SURVEY_QUOTA_ID_LENGTH);
};
